import { observer } from 'mobx-react-lite';
import React from 'react';
import { getUserNames } from '../../../common/string/get-user-names';
import { AwardJudging } from '../../../models';
import './AwardJudgingBox.scss';

interface AwardJudgingBoxProps {
  awardJudging: AwardJudging;
  alertMessage?: string;
  onJudgingButtonClicked(): void;
}

const AwardJudgingBoxImpl: React.FC<AwardJudgingBoxProps> = (props) => {
  const {
    awardJudging,
    alertMessage,
    onJudgingButtonClicked
  } = props;

  return (
    <div
      className='award-judging-box'
    >
      <span>
        {awardJudging.title}
      </span>
      <h4
        className='group'
      >
        {awardJudging.group}
      </h4>
      <span
        className='primary-lead'
      >
        {
          `Primary lead: ${awardJudging.primaryLead ? getUserNames([awardJudging.primaryLead]) : awardJudging.emailAddress ?? '-'}`
        }
      </span>
      {
        alertMessage &&
        <span className='error-message'>{alertMessage}</span>
      }
      {
        awardJudging.isJudgingComplete &&
        <span>Judging is complete for this award.</span>
      }
      {
        !alertMessage &&
        !awardJudging.isJudgingComplete &&
        <button
          onClick={onJudgingButtonClicked}
        >
          {awardJudging.judgingStarted ? 'Continue' : 'Start judging'}
        </button>
      }
    </div>
  );
}

export const AwardJudgingBox = observer(AwardJudgingBoxImpl);